
export const isMailDomain = () => !window.location.hostname.endsWith('.wemomo.com');

export default {};
